<template>
  <div class="bid-dashboard-page">
    <BidDashboardBoard />
  </div>
</template>

<script>
import BidDashboardBoard from '@/components/panel/BidDashboardBoard.vue';

export default {
  routerOption: {
    as_default: true,
  },
  components: {
    BidDashboardBoard,
  },
};
</script>

<style scoped>
.bid-dashboard-page {
  height: 100%;
  overflow: hidden;
}
</style>
